import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default function boxSliderGridScript() {

  const boxSliders = document.querySelectorAll('.c-boxes-grid__top-image-slider');

  if (!boxSliders) {
    return;
  }  

  boxSliders.forEach((boxSlider) => {
    const swiperBoxes = new Swiper(boxSlider, {
      modules: [Navigation, Autoplay],
      centeredSlides: true,
      slidesPerView: 1,
      initialSlide: 1,
      spaceBetween: 24,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      }
    });
  });
  
}

